module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-574.a7ff436.woff2";